import { Model } from '@models/core/base.model';

// This model does not have a index endpoint

export class TimeOffBackupApprover extends Model {
    protected static _resource = 'timeOffV3/timeOffBackupApprovers';

    protected static _version = 'v2';

    protected static _type = 'timeOffBackupApprovers';

    protected static _serializeAttributes = ['approverId'];

    get companyId(): number {
        return this._attributes['comapnyId'];
    }

    get approverId(): number {
        return this._attributes['approverId'];
    }

    set approverId(val: number) {
        this._attributes['approverId'] = val;
    }
}
